export * from './baChartistChart.component';



// WEBPACK FOOTER //
// /app/src/app/theme/components/baChartistChart/index.ts